import { render, staticRenderFns } from "./storySummary.vue?vue&type=template&id=6e061092&scoped=true"
import script from "./storySummary.vue?vue&type=script&lang=js"
export * from "./storySummary.vue?vue&type=script&lang=js"
import style0 from "./storySummary.vue?vue&type=style&index=0&id=6e061092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e061092",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QImg,QScrollArea,QBtn});
